var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53001 13.77C1.31701 15.164 2.26801 16.131 3.43201 16.613C7.89501 18.463 14.105 18.463 18.568 16.613C19.732 16.131 20.683 15.163 20.47 13.77C20.34 12.913 19.693 12.2 19.214 11.503C18.587 10.579 18.525 9.572 18.524 8.5C18.525 4.358 15.157 1 11 1C6.843 1 3.47501 4.358 3.47501 8.5C3.47501 9.572 3.41301 10.58 2.78501 11.503C2.30701 12.2 1.66101 12.913 1.53001 13.77Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18C7.458 19.725 9.076 21 11 21C12.925 21 14.541 19.725 15 18",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNormal);
export default __webpack_public_path__ + "static/media/notification-normal.90b3c7460e82d06b7bd16de0f4cefb37.svg";
export { ForwardRef as ReactComponent };